"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Decoder = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _abi = require("@ethersproject/abi");
var _bignumber = require("@ethersproject/bignumber");
var _CustomCoder = require("./CustomCoder");
var diff = _interopRequireWildcard(require("fast-array-diff"));
var _ethTypes = require("@blockwell/eth-types");
var _ErrorCodes = _interopRequireDefault(require("./ErrorCodes"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const BuiltinErrors = {
  "08c379a0": {
    name: "Error",
    inputs: [{
      type: "string",
      name: "message"
    }],
    type: "builtin"
  },
  "4e487b71": {
    name: "Panic",
    inputs: [{
      type: "uint256"
    }],
    type: "builtin"
  }
};

/**
 * A class that decodes Ethereum method input and logs.
 */
class Decoder {
  constructor(data) {
    (0, _defineProperty2.default)(this, "data", void 0);
    (0, _defineProperty2.default)(this, "interface", new _CustomCoder.CustomInterface([]));
    (0, _defineProperty2.default)(this, "funcs", void 0);
    (0, _defineProperty2.default)(this, "errors", void 0);
    this.data = data;
    this.funcs = data.func.bind(data);
    this.errors = data.error.bind(data);
  }
  method(input, cache) {
    return this.methodLike(input, this.funcs, cache);
  }
  async error(input, cache) {
    // No proper data is less than 4 characters. Could be 0x or 0x0.
    if (input.length < 4) {
      return null;
    }
    let trimmed = input.toLowerCase();
    if (trimmed.startsWith("0x")) {
      trimmed = trimmed.slice(2);
    }

    // Blockwell custom error codes are bytes2, so 4 hex characters
    if (trimmed.length === 4 && trimmed.startsWith("e")) {
      let error = _ErrorCodes.default[trimmed];
      if (error) {
        return error;
      }
    }
    return await this.methodLike(trimmed, this.errors, cache);
  }
  async methodLike(input, loader, cache) {
    let sig = input.slice(0, 8);
    let result;
    let builtIn = BuiltinErrors[sig];
    if (builtIn) {
      result = [builtIn];
    } else {
      if (cache) {
        result = cache[sig];
      }
      if (!Array.isArray(result)) {
        result = await loader(sig);
        if (cache) {
          cache[sig] = result;
        }
      }
    }
    if (!result || result.length === 0) {
      return null;
    }
    result.sort((a, b) => {
      var _b$inputs, _a$inputs;
      return ((_b$inputs = b.inputs) === null || _b$inputs === void 0 ? void 0 : _b$inputs.length) || 0 - ((_a$inputs = a.inputs) === null || _a$inputs === void 0 ? void 0 : _a$inputs.length) || 0;
    });
    let results = [];
    for (let abi of result) {
      try {
        let dec;
        if (abi.type === "error" || abi.type === "builtin") {
          dec = this.tryError(input, abi);
        } else {
          dec = this.tryMethod(input, abi);
        }
        results.push({
          decoded: dec.decoded,
          abi,
          distance: dec.distance
        });
      } catch (err) {}
    }
    if (results.length === 0) {
      return null;
    }
    results.sort((a, b) => a.distance - b.distance);
    return results.map(it => {
      return {
        name: it.abi.name,
        inputs: it.decoded,
        distance: it.distance
      };
    });
  }
  tryMethod(input, abi) {
    let f = {
      ...abi
    };
    if (!f.stateMutability) {
      f.stateMutability = "payable";
    }
    let frag = _abi.FunctionFragment.from(f);
    let decoded = this.interface.decodeFunctionData(frag, "0x" + input);
    let params = this.decodeToParameters(decoded, abi);
    let encoded;
    try {
      encoded = this.interface.encodeFunctionData(frag, (0, _ethTypes.ethParamsToValues)(params));
    } catch (err) {}
    return {
      distance: this.decodeDistance(input, encoded),
      decoded: params
    };
  }
  tryError(input, abi) {
    let decoded;
    let frag;
    if (abi.type === "builtin") {
      decoded = this.interface._abiCoder.decode(abi.inputs, "0x" + input.slice(8));
    } else {
      frag = _abi.ErrorFragment.from(abi);
      decoded = this.interface.decodeErrorResult(frag, "0x" + input);
    }
    let params = this.decodeToParameters(decoded, abi);
    let distance;
    if (frag) {
      let encoded;
      try {
        encoded = this.interface.encodeErrorResult(frag, (0, _ethTypes.ethParamsToValues)(params)).slice(2);
      } catch (err) {}
      distance = this.decodeDistance(input, encoded);
    } else {
      distance = 0;
    }
    return {
      distance,
      decoded: params
    };
  }
  decodeToParameters(decoded, abi) {
    let params = [];
    let i = 0;
    if (abi.inputs) {
      for (let it of abi.inputs) {
        params.push(Decoder.convertParam(_ethTypes.Typing.parse(it), decoded[i]));
        ++i;
      }
    }
    return params;
  }
  decodeDistance(input, encoded) {
    let exact = encoded === input;
    let distance = 0;
    if (!exact) {
      distance = Decoder.functionEncodingDistance(input, encoded);
    }
    return distance;
  }
  logs(events) {
    return Promise.all(events.map(it => this.log(it)));
  }
  async log(event) {
    if (!event || !event.topics || event.topics.length === 0) {
      return null;
    }
    const topic0 = event.topics[0].slice(2);
    const result = await this.data.event(topic0);
    if (!result || result.length < 1) {
      return null;
    }
    let decoded;
    for (let abi of result) {
      try {
        let dec = this.tryLog(event, abi);
        if (dec) {
          decoded = dec;
          break;
        }
      } catch (err) {}
    }
    return decoded;
  }
  tryLog(event, abi) {
    let decoded = this.interface.decodeEventLog(_abi.EventFragment.from(abi), event.data, event.topics);
    let params = [];
    let i = 0;
    for (let it of abi.inputs) {
      params.push(Decoder.convertParam(_ethTypes.Typing.parse(it), decoded[i]));
      ++i;
    }
    return {
      event: abi.name,
      params,
      timestamp: event.timestamp
    };
  }
  static convertParam(typing, value) {
    let it = {
      type: typing.toString()
    };
    if (typing.parameterName) {
      it.name = typing.parameterName;
    }
    if (typing.indexed) {
      it.indexed = true;
    }
    if (value instanceof _abi.Indexed) {
      it = {
        ...it,
        hash: value.hash
      };
    } else {
      if (typing.array) {
        if (!Array.isArray(value)) {
          throw new Error("Decoder type is an array, but it was not an array value: " + value + " - " + typing);
        }
        if (typing.name === "tuple") {
          let param = {
            ...it,
            values: []
          };
          for (let element of value) {
            param.values.push(this.convertParam(typing.arrayElement(), element));
          }
          it = param;
        } else if (typing.name === "bool") {
          it = {
            ...it,
            values: value.map(it => !!it)
          };
        } else {
          it = {
            ...it,
            values: value.map(it => {
              if (_bignumber.BigNumber.isBigNumber(it)) {
                return it.toString();
              } else if (typeof it === "number") {
                return it.toString();
              } else if (typeof it.bytes === "string") {
                return it.bytes;
              } else {
                return it;
              }
            })
          };
        }
      } else {
        if (Array.isArray(value)) {
          if (typing.name === "tuple") {
            let param = {
              ...it,
              components: []
            };
            let list = [].concat(value);
            for (let comp of typing.components) {
              param.components.push(this.convertParam(comp, list.shift()));
            }
            it = param;
          } else {
            throw new Error("Decoder received an array value, but it was not an array or tuple type: " + value + " - " + typing);
          }
        } else if (typing.name === "bool") {
          it = {
            ...it,
            value: !!value
          };
        } else {
          let param = {
            ...it,
            value: null
          };
          if (_bignumber.BigNumber.isBigNumber(value)) {
            param.value = value.toString();
          } else if (typeof value === "number") {
            param.value = value.toString();
          } else if (value.bytes) {
            param.bytes = value.bytes;
          } else {
            param.value = value;
          }
          it = param;
        }
      }
    }
    return it;
  }
  static functionEncodingDistance(original, encoded) {
    let left = original.slice(8).match(/.{1,64}/g) || [];
    let right = encoded.slice(8).match(/.{1,64}/g) || [];
    let ops = diff.diff(left, right);
    return ops.removed.length + ops.added.length;
  }
}
exports.Decoder = Decoder;
//# sourceMappingURL=Decoder.js.map